import $ from 'jquery'

export default {
    name: 'manage-annulation',
    components: {},
    props: {
        justification: String,
        annul_operations: Array,
        modal_toggler: Number,
        user_id: Number,
        demandeur_id: Number
    },
    data() {
        return {
            fields: [
                { key: 'choix_operation', label: '#' }, { key: 'ref', label: 'Référence' }, { key: 'libelle', label: 'Libellé' },
                { key: 'montant', label: 'Montant' }, { key: 'client_rembourse', label: 'Client remboursé' },
                { key: 'retour_stock', label: 'Retour stock' }, { key: 'resp_retour_stock', label: 'Action retour stock' },
                { key: 'compte_source', label: 'Compte source' }
            ],
            perPage: -1,
            currentPage: 1,

            operations_tobe_canceled: [],
            save_loading: false,
            can_ask_cancelation: false,
            has_checked_retour_stock: true,
            has_checked_compte: true,
            is_confirm: false,
            operation_is_empty: false,
            confirmation_message: '',

            comptes_sources: [
                { id: 6, libelle: 'Trésorerie' }
            ],
            selected_compte_sources: [],

            total_rembourse_caisse: 0,
            total_rembourse_compte_depot: 0,
            solde_caisse_is_less: false,
            solde_compte_depot_is_less: false,

            caisse_is_chosen: false,
            compte_depot_is_chosen: false,

            accept_is_visible: true,
            reject_is_visible: true,
            compte_id: 0,
        }
    },

    watch: {
        modal_toggler() {
            this.is_confirm = false
            this.can_ask_cancelation = false
            this.has_checked_compte = true
            this.has_checked_retour_stock = true
            this.operations_tobe_canceled = []
            this.setConditionDemandeAnnulation()

            this.compte_id = this.annul_operations[0].compte_id

            this.getSoldeCaisseDisponible()
            this.getSoldeCompteDepot()
        },

        operations_tobe_canceled() {
            this.operation_is_empty = false
            if (this.operations_tobe_canceled.length > 0) {
                this.can_ask_cancelation = true
            } else {
                this.can_ask_cancelation = false
            }
        },
    },

    computed: {
        solde_disponible() {
            return this.$store.getters["solde_disponible"];
        },

        solde_compte_depot() {
            return this.$store.getters["solde_compte_depot"];
        },

        cancellation_observer() {
            return this.$store.getters["cancellation_observer"];
        },
    },

    mounted() {
        
    },

    methods: {
        setCompteSource(index) {
            this.annul_operations[index].compte_source = this.selected_compte_sources[index]
        },

        toggleRetorStock(index, value) {
            this.has_checked_retour_stock = true
            this.annul_operations[index].reponse_retour_stock = value
        },

        toggleCompteSource(index, value) {
            this.solde_compte_depot_is_less = false
            this.solde_caisse_is_less = false
            this.has_checked_compte = true
            this.annul_operations[index].compte_source = value
        },


        setConditionDemandeAnnulation() {
            let i = 0
            this.annul_operations.forEach((operation) => {
                this.annul_operations[i].reponse_retour_stock = (operation.data_type == 'consommable_bon')?operation.retour_stock:null
                this.annul_operations[i].compte_source = (operation.rembourse_client == 1)?operation.compte_id:null
                i++
            });
        },

        checkIfReturningStockIsSet() {
            let has_checked_retour_stock = true
            this.operations_tobe_canceled.forEach(operation => {
                if (operation.data_type === 'consommable_bon') {
                    if (operation.reponse_retour_stock == null) {
                        has_checked_retour_stock = false
                    }
                }
            });
            return has_checked_retour_stock
        },

        checkIfHasCheckedCompte() {
            let has_checked_compte = true
            this.operations_tobe_canceled.forEach(operation => {
                if (operation.compte_source == null) {
                    has_checked_compte = false
                }
            });
            return has_checked_compte
        },

        calcTotalMontantRembourseByCompte() {
            this.total_rembourse_caisse = 0
            this.total_rembourse_compte_depot = 0

            this.compte_depot_is_chosen = false
            this.caisse_is_chosen = false

            this.operations_tobe_canceled.forEach(operation => {
                if (operation.type_operation == 1) {
                    if (operation.compte_source == 6) {
                        // Compte dépôt
                        this.total_rembourse_compte_depot += operation.montant_paye
                        this.compte_depot_is_chosen = true
                    } else {
                        // Caisse
                        this.total_rembourse_caisse += operation.montant_paye
                        this.caisse_is_chosen = true
                    }
                }
            });
        },

        getSoldeCaisseDisponible() {
            const data = {
                compte_id: this.compte_id,
                date: this.getDates().today_date,
                user_id: this.demandeur_id
            }
            this.$store.dispatch("getSoldeDisponible", data).then(() => {
                this.solde_courant = parseInt(this.solde_disponible);
            })
        },

        getSoldeCompteDepot() {
            const data = {
                month: "",
                one_date: this.getDates().today_date,
                from_date: "",
                to_date: ""
            }
            this.$store.dispatch("getSoldeCourantCompteDepot", data)
        },

        getDates() {
            let today_date = new Date();
            let yesterday_date = new Date();
            yesterday_date.setDate(today_date.getDate() - 1);
            today_date = `${today_date.getFullYear()}-${today_date.getMonth() + 1}-${today_date.getDate()}`;
            yesterday_date = `${yesterday_date.getFullYear()}-${yesterday_date.getMonth()+1}-${yesterday_date.getDate()}`;
            return { today_date, yesterday_date };
        },

        submit(state, selector) {
            if (this.operations_tobe_canceled.length == 0) {
                this.operation_is_empty = true
                return
            }

            this.calcTotalMontantRembourseByCompte()

            if (state === 'accepter') {
                // Vérifier si une action est décidée pour  le retour de stock
                this.has_checked_retour_stock = this.checkIfReturningStockIsSet()

                this.has_checked_compte = this.checkIfHasCheckedCompte()

                // Vérifier si le solde en caisse est suffisant  pour le remboursement
                if (this.caisse_is_chosen) {
                    if (this.solde_disponible < this.total_rembourse_caisse) {
                        this.solde_caisse_is_less = true
                    }
                }

                // Vérifier si le solde compte de dépôt est suffisant pour le remboursement
                if (this.compte_depot_is_chosen) {
                    if (this.solde_compte_depot < this.total_rembourse_compte_depot) {
                        this.solde_compte_depot_is_less = true
                    }
                }
                this.accept_is_visible = true
                this.reject_is_visible = false
            } else {
                this.accept_is_visible = false
                this.reject_is_visible = true

                let i = 0
                this.operations_tobe_canceled.forEach(() => {
                    this.annul_operations[i].reponse_retour_stock = null
                    this.annul_operations[i].compte_source = null
                    i++
                });
            }

            if (!this.has_checked_retour_stock) {
                this.is_confirm = false
                return;
            }

            if (!this.has_checked_compte) {
                this.is_confirm = false
                return;
            }

            if (this.solde_caisse_is_less) {
                return;
            }

            if (this.solde_compte_depot_is_less) {
                return;
            }

            if (!this.is_confirm) {
                this.is_confirm = true

                if (state === 'accepter') {
                    this.confirmation_message = "Je confirme vouloir valider la demande d'annulation des opérations choisies ci-dessus"
                } else {
                    this.confirmation_message = "Je confirme vouloir rejeter la demande d'annulation des opérations choisies ci-dessus"
                }

                return;
            }

            const confirm = document.getElementById(selector);
            if (!confirm.checked) {
                $('.err-msg').fadeIn(500)
                return;
            }
            const data = {
                etat_annulation: (state === 'accepter') ? 1 : 2,
                user_id: this.user_id,
                operations_tobe_canceled: this.operations_tobe_canceled
            }

            this.save_loading = true
            this.$store.dispatch('validerDemandeAnnulation', data).then((response) => {
                if (response.success) {

                    this.$emit('emitDemandeAnnulation')
                    
                    this.$refs.d_annulation.click()
                    this.$store.commit("SET_CANCELLATION_OBSERVER", (this.cancellation_observer == 0)?1:0);
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
            })
        },

        onConfirm() {
            $('.err-msg').fadeOut(500);
        },
    }
}